// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.succesBox {
  overflow: hidden;
  display: block;
}
.succesBox.-related {
  margin-bottom: var(--m_relatedContents);
}
.succesBox.-element {
  margin-bottom: var(--m_elements);
}
.succesBox__container {
  text-align: center;
  border-radius: 4px;
  overflow: hidden;
}
.succesBox__header {
  background-color: var(--c_mainColorDark);
  position: relative;
}
.succesBox__check {
  position: relative;
  top: 17px;
  transform: scale(1.06);
}
.succesBox__check svg {
  height: 80px;
  filter: drop-shadow(0 0px 4px rgba(0, 0, 0, 0.1));
}
.succesBox__check svg .fill {
  fill: var(--c_backgroundBox);
}
.succesBox__exit {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.succesBox__exit visiba-svg {
  width: inherit;
  height: inherit;
}
.succesBox__exit visiba-svg .fill {
  fill: var(--c_backgroundBox);
}
.succesBox__info {
  background-color: var(--c_backgroundBox);
  padding: 30px 10px 0;
}
.succesBox__info__receiptUrl {
  font-size: 12px;
}
.succesBox__action {
  font-size: 12px;
  display: flex;
  justify-content: center;
  line-height: 12px;
  padding-bottom: var(--m_components);
}
.succesBox__href {
  color: var(--c_mainColorLight);
  cursor: pointer;
  font-weight: 600;
}
.succesBox h2 {
  color: var(--c_textBody);
  font-weight: 600;
  font-size: 1.25em;
  margin: 0;
  margin-bottom: 0.3em;
}
.succesBox p {
  margin-bottom: var(--m_elements);
}
.succesBox .btn {
  margin-top: 20px;
  width: 30%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
